module.exports = __webpack_public_path__ + "static/media/Telegram.1bdd7d9b.svg";